export const userInfoSelector = (state) => state;
  